import React from 'react';
import { Text } from './Text';
export const SubHeader = ({ children }) => {
    return (React.createElement(Text, { fontWeight: 'normal', level: '5', textColorVariant: 'primary', className: 'cb-subheader' }, children));
};
